export default {"src":"/_next/static/media/users.34ad5930.svg","height":75,"width":76,"blurWidth":0,"blurHeight":0};